import { render, staticRenderFns } from "./qrcode-paper-add.vue?vue&type=template&id=af6703a4&scoped=true&"
import script from "./qrcode-paper-add.vue?vue&type=script&lang=js&"
export * from "./qrcode-paper-add.vue?vue&type=script&lang=js&"
import style0 from "./qrcode-paper-add.vue?vue&type=style&index=0&id=af6703a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6703a4",
  null
  
)

export default component.exports